class CityModal extends HTMLElement {
    constructor() {
        super();
        this.klaviyoFormIds = {
            ar: 'WNVwJu',
            en: 'V6M25A'
        };
    }

    open() {
        const modal = this.querySelector('.city--modal');
        modal?.classList.add('city--modal--active');
    }

    close() {
        const modal = this.querySelector('.city--modal');
        modal?.classList.remove('city--modal--active');
    }

    getCurrentLanguage() {
        const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
        if (htmlLang.startsWith('ar')) return 'ar';
        if (htmlLang.startsWith('en')) return 'en';

        const shopifyLocale = (window.Shopify?.locale || '').toLowerCase();
        if (shopifyLocale === 'ar' || shopifyLocale === 'en') return shopifyLocale;

        const preferredLanguage = (localStorage.getItem('preferred_language') || '').toLowerCase();
        if (preferredLanguage === 'ar' || preferredLanguage === 'en') return preferredLanguage;

        return 'en';
    }

    getKlaviyoFormId() {
        const lang = this.getCurrentLanguage();
        return this.klaviyoFormIds[lang] || this.klaviyoFormIds.en;
    }

    triggerKlaviyoForm() {
        const formId = this.getKlaviyoFormId();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
    }

    runPendingKlaviyoForm() {
        const shouldOpen = sessionStorage.getItem('openKlaviyoLocationForm');
        if (shouldOpen !== 'true') return;

        sessionStorage.removeItem('openKlaviyoLocationForm');
        this.triggerKlaviyoForm();
    }

    connectedCallback() {
        const isLocationPicked = sessionStorage.getItem('locationPicked');
        this.runPendingKlaviyoForm();

        if (isLocationPicked !== 'true') {
            this.open();
        }

        const closeButton = this.querySelector('.city--modal__close');
        if (closeButton) {
            closeButton.addEventListener('click', () => this.close());
        }

        const confirmButton = this.querySelector('.city--modal__confirm button');
        if (confirmButton) {
            confirmButton.addEventListener('click', () => {
                const locForm = this.querySelector('localization-form');
                let pendingCity = locForm ? locForm.getAttribute('data-pending-city') : null;
                
                if (!pendingCity) {
                    pendingCity = (localStorage.getItem('selectedCity') || window.defaultCity || 'RIYADH').trim();
                    if (pendingCity !== 'RIYADH' && pendingCity !== 'OTHER CITY') {
                        if (pendingCity === window.locations?.OTHER_CITY || pendingCity === window.locations?.OTHER_CITIES || pendingCity === window.locations?.JEDDAH || pendingCity === window.locations?.DOHA) {
                            pendingCity = 'OTHER CITY';
                        } else if (pendingCity === window.locations?.RIYADH) {
                            pendingCity = 'RIYADH';
                        }
                    }
                }

                if (locForm && typeof locForm.applyCitySelection === 'function') {
                    locForm.applyCitySelection(pendingCity);
                }

                if (pendingCity === 'OTHER CITY') {
                    sessionStorage.removeItem('openKlaviyoLocationForm');
                    this.close();
                    this.triggerKlaviyoForm();
                } else {
                    this.close();
                }
            });
        }
    }
}

customElements.define('city-modal', CityModal);